var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbedButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5C3 2.77614 2.77614 3 2.5 3C2.22386 3 2 2.77614 2 2.5C2 2.22386 2.22386 2 2.5 2C2.77614 2 3 2.22386 3 2.5Z",
    fill: "#202123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4.27614 3 4.5 2.77614 4.5 2.5C4.5 2.22386 4.27614 2 4 2C3.72386 2 3.5 2.22386 3.5 2.5C3.5 2.77614 3.72386 3 4 3Z",
    fill: "#202123"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2C5.22386 2 5 2.22386 5 2.5C5 2.77614 5.22386 3 5.5 3Z",
    fill: "#202123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V12C16 13.1046 15.1046 14 14 14H2C0.895431 14 0 13.1046 0 12V2ZM15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V4H15V2ZM1 5V12C1 12.5523 1.44772 13 2 13H14C14.5523 13 15 12.5523 15 12V5H1Z",
    fill: "#202123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76517 6.23484C2.61872 6.08839 2.38128 6.08839 2.23483 6.23484C2.08839 6.38128 2.08839 6.61872 2.23483 6.76516L2.96967 7.5L2.23483 8.23483C2.08839 8.38128 2.08839 8.61872 2.23483 8.76517C2.38128 8.91161 2.61872 8.91161 2.76517 8.76517L3.58839 7.94194C3.83247 7.69786 3.83247 7.30214 3.58839 7.05806L2.76517 6.23484Z",
    fill: "#202123"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.625C4.29289 8.625 4.125 8.79289 4.125 9C4.125 9.20711 4.29289 9.375 4.5 9.375H5.5C5.70711 9.375 5.875 9.20711 5.875 9C5.875 8.79289 5.70711 8.625 5.5 8.625H4.5Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedButton);
export default __webpack_public_path__ + "static/media/embedButton.7abf6b2a5b8b0eafdf23c648bfa3dd96.svg";
export { ForwardRef as ReactComponent };